import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';

export class ProjectTaskStatusForm extends CerFormAdapter {

  override viewSetInit(viewSet: CerFormViewSet): void {

    const view = new CerFormView();
    view.viewMetadata = {
      name: 'projekt-opgave-status', dataApiName: 'ProjectTaskStatus', text: 'Opgavestatus',
      primaryKey: 'num', baseFields: ['id','num','history']
    };

    view.fieldMetadata = [
        { name: 'num', text: 'Status' },
        { name: 'name', text: 'Statusnavn' },
        { name: 'isClosed', text: 'Lukket?', format: 'CheckBox' }
      ];

    viewSet.viewAdd(view);
  }

}
